import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "reactstrap";
import LineGraph from "../Component/LineGraph";

import FinanceRadar from "../Component/FinanceRadar";
import { useQuery } from "@apollo/client";
import { GET_FINANTIAL_COMPARISON_DATA } from "../../../../queries";

/**
 * 比較分析PAGE/財務データSECTION
 * @param {*} param0
 * @returns
 */

const FinanceData = ({ orgIdArray, orgPk, avePk, target }) => {
  const [targetData, setTargetData] = useState("");

  const { loading, error, data } = useQuery(GET_FINANTIAL_COMPARISON_DATA, {
    variables: { orgPks: orgIdArray, orgPk2: orgPk, scaleAverageId: avePk },
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          // src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    // alert("ログイン制限時間が切れました、再リロードしてください。");
    alert(error);
    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  //他団体データ
  let comparisonOtherOrgData = JSON.parse(data.comparisonData.data);

  //業界平均データ
  let comparisonIndustryFiscalData = JSON.parse(
    data.comparisonData.industryFiscalData
  );

  //規模別平均データ
  let { revenueCategoryData } = data;
  revenueCategoryData = JSON.parse(revenueCategoryData.data);

  const latestYear = comparisonOtherOrgData.categories.slice(-1)[0];

  return (
    <div>
      <Card className="mb-2 org_contentarea financialcomparison">
        <div className="org_subtitle_sec">
          <h4 className="org_subtitle">財務データ</h4>
        </div>
        <div className="org_item comparion_item">
          <Row>
            <Col md="6" lg="5">
              <p>{latestYear}年 単年度データ</p>
              {target === "業界平均" ? (
                <FinanceRadar
                  comparisonData={comparisonIndustryFiscalData}
                  target={target}
                />
              ) : (
                <>
                  {target === "組織規模" ? (
                    <FinanceRadar
                      comparisonData={revenueCategoryData}
                      target={target}
                    />
                  ) : (
                    <FinanceRadar
                      comparisonData={comparisonOtherOrgData}
                      target={target}
                    />
                  )}
                </>
              )}
            </Col>
            <Col md="6" lg="7" className="transitioncomparison">
              <p>経年変化データ</p>
              {target === "業界平均" ? (
                <LineGraph comparisonData={comparisonIndustryFiscalData} />
              ) : (
                <>
                  {target === "組織規模" ? (
                    <LineGraph comparisonData={revenueCategoryData} />
                  ) : (
                    <LineGraph comparisonData={comparisonOtherOrgData} />
                  )}
                </>
              )}
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );
};

export default FinanceData;
